<template>
  <div>
    <pcHeader></pcHeader>
    <div class="pc_goods_detail_box">
      <div class="pc_goods_list_nav clearfix_">
        <div class="clearfix_ fl">
          <div @click="gotoIndex" class="pc_goods_list_nav_item fl">首页&nbsp<span>></span>&nbsp</div>
          <div @click="gotoCategory(item.id)" v-for="(item,index) in categoryStr" :key="index" class="pc_goods_list_nav_item fl">{{item.name}}&nbsp<span>></span>&nbsp</div>
        </div>
      </div>
      <div class="pc_goods_detail_content clearfix_">
        <div class="fl pc_goods_detail_left">
          <div class="pc_goods_detail_left_pic">
            <pic-zoom :url="bigImg" :scale="2.5" style=""></pic-zoom>
            <div v-if="goodsData.activityContent" class="pc_goods_detail_activity">
              <div class="pc_goods_detail_activity_img"><img :src="goodsData.activityPic" alt=""></div>
              <div class="pc_goods_detail_activity_txt">{{goodsData.activityContent}}</div>
            </div>
          </div>
          <div class="pc_goods_detail_left_img_box clearfix_">
            <!-- <div class="pc_goods_detail_left_img_prev"></div> -->
            <div class="pc_goods_detail_left_img_list_box">
              <div class="pc_goods_detail_left_img_list clearfix_">
                <div @click="changBigImg(item)" :style="{border:(bigImg==item?'1px solid #e00':'1px solid transparent')}" v-for="(item,index) in goodsImgList" :key="index" v-if="item" class="pc_goods_detail_left_img_item fl"><img :src="item" alt=""></div>
              </div>
            </div>
            <!-- <div class="pc_goods_detail_left_img_next"></div> -->
          </div>
          <div class="pc_goods_detail_left_function clearfix_">
            <div @click="collectionGoods" class="fl pc_goods_detail_left_function_txt pc_goods_detail_left_function_collect"><img v-if="goodsData.isCollection==1" src="http://img.source.9188cn.com/pc_goods_detail_collect_red.png" alt=""><img v-if="goodsData.isCollection==2" src="http://img.source.9188cn.com/pc_goods_detail_collect.png" alt="">{{goodsData.isCollection==1?'已收藏':'收藏'}}</div>
            <div @click="shareGoods" class="fl pc_goods_detail_left_function_txt pc_goods_detail_left_function_share"><img src="http://img.source.9188cn.com/pc_goods_detail_share.png" alt="">分享</div>
            <div @click="scanCodeByPhone" class="fl pc_goods_detail_left_function_txt pc_goods_detail_left_function_code"><img src="http://img.source.9188cn.com/pc_goods_detail_code.png" alt="">扫码购</div>
          </div>
          <div v-show="shareShow" class="bdsharebuttonbox clearfix_">
            <a href="javascript:void(0)" class="bds_qzone" data-cmd="qzone"></a>
            <a href="javascript:void(0)" class="bds_tsina" data-cmd="tsina"></a>
            <a href="javascript:void(0)" class="bds_tqq" data-cmd="tqq"></a>
            <a href="javascript:void(0)" class="bds_renren" data-cmd="renren"></a>
          </div>
        </div>
        <div class="fl pc_goods_detail_right">
          <div class="pc_goods_detail_right_name1">{{goodsTxtData.name}}</div>
          <div class="pc_goods_detail_right_name2">{{goodsTxtData.goodsSellPoint}}</div>
          <div class="pc_goods_detail_right_txt_box">
            <div v-if="spellGroupData.spellStatus==2" class="pc_goods_detail_right_team">
              <span class="fl">拼团价格：</span><i class="fl">{{spellGroupData.minPrice}}</i><i v-if="spellGroupData.minPrice!=spellGroupData.maxPrice" class="fl">&nbsp;-&nbsp;{{spellGroupData.maxPrice}}</i>
            </div>
            <div class="pc_goods_detail_right_price clearfix_">
              <div class="fl pc_goods_detail_right_price_txt">价格：</div>
              <div class="fl pc_goods_detail_right_price_num1">{{goodsTxtData.price}}</div>
              <div v-show="goodsTxtData.price!=goodsTxtData.lrprice" class="fl pc_goods_detail_right_price_num2">{{goodsTxtData.lrprice}}</div>
            </div>
            <div v-if="couponList.length" class="pc_goods_detail_right_coupon clearfix_">
              <div class="fl pc_goods_detail_right_price_txt">优惠券：</div>
              <div class="fl pc_goods_detail_right_coupon_list">
                <div v-for="(item,index) in couponList" :key="index" class="pc_goods_detail_right_coupon_item clearfix_">
                  <div class="pc_goods_detail_right_coupon_item_price fl">¥{{item.price}}</div>
                  <div class="pc_goods_detail_right_coupon_item_txt fl">{{item.useRange}} {{item.condition}}{{item.goodsNum}}{{item.method}}可用</div>
                  <div @click="receiveCoupon(item.id,item.count)" :class="{'pc_goods_detail_right_coupon_item_btn_active':item.count<1}" class="pc_goods_detail_right_coupon_item_btn fl">{{item.count<1?'已领':'领取'}}</div>
                </div>
              </div>
              <div v-show="couponList.length>2" class="fl pc_goods_detail_right_coupon_more">{{couponMore?'更多':'收起'}}</div>
            </div>
            <div v-if="goodsPromotionList.length" class="pc_goods_detail_right_goods_promotion clearfix_">
              <div class="fl pc_goods_detail_right_price_txt">商品促销：</div>
              <div :style="{height:(moreGoodsPromotion?'auto':goodsPromotionList.length==1?'22px':'54px')}" class="fl pc_goods_detail_right_coupon_list">
                <div v-for="(item,index) in goodsPromotionList" :key="index" class="pc_goods_detail_right_goods_promotion_item clearfix_">
                  <div class="pc_goods_detail_right_goods_promotion_item_title fl">{{item.methodType}}</div>
                  <div :title="item.condition + item.method + item.method + item.pmnPrivilege + ' ' + item.overlap" class="pc_goods_detail_right_goods_promotion_item_txt fl">{{item.condition}}{{item.method}}{{item.pmnPrivilege}} {{item.overlap}}</div>
                </div>
              </div>
              <div @click="moreGoodsPromotionFn" v-if="goodsPromotionList.length>2" class="fl pc_goods_detail_right_coupon_more">{{moreGoodsPromotion?'收起':'更多'}}</div>
            </div>
            <div class="pc_goods_detail_right_order_promotion clearfix_">
              <div class="fl pc_goods_detail_right_price_txt">其他促销：</div>
              <div class="fl pc_goods_detail_right_coupon_list">
                <div v-show="otherPromotionList.length" v-for="(item,index) in otherPromotionList" :key="index" class="pc_goods_detail_right_goods_promotion_item clearfix_">
                  <div class="pc_goods_detail_right_goods_promotion_item_title fl">{{item.methodType}}</div>
                  <div :title="item.condition+item.method+item.pmnPrivilege" class="pc_goods_detail_right_goods_promotion_item_txt fl">{{item.condition}}{{item.method}}{{item.pmnPrivilege}}</div>
                </div>
                <div @click="getOtherPromotionData" class="pc_goods_detail_right_coupon_more">{{moreOtherPromotion?'点击收起':'点击查看'}}</div>
              </div>
              
            </div>
          </div>
          <div v-if="scoreGoodsList.length" class="pc_goods_detail_right_score_change clearfix_">
            <div class="fl pc_goods_detail_right_score_change_title">换购：</div>
            <div class="fl pc_goods_detail_right_score_change_list">
              <div v-for="(item,index) in scoreGoodsList" :key="index" @click="changeScoreGoodsItem(item)" :class="{'pc_goods_detail_right_score_change_item_active':item.isChecked}" class="pc_goods_detail_right_score_change_item">{{item.info}} {{item.unitPropertyNames}}</div>
            </div>
          </div>
          <div class="pc_goods_detail_right_attr_list">
            <div v-show="item.attribute_val.length" v-for="(item,index) in goodsData.attributes" :key="index" class="pc_goods_detail_right_attr_item clearfix_">
              <div class="pc_goods_detail_right_attr_item_name fl">{{item.name}}：</div>
              <div class="pc_goods_detail_right_attr_item_list fl clearfix_">
                <div @click="changeAttrVal(index,idx)" v-for="(val,idx) in item.attribute_val" :key="idx" :class="{'pc_goods_detail_right_attr_val_active':val.isChecked,'pc_goods_detail_right_attr_val_prohibit':prohibitChangeAttr}" class="pc_goods_detail_right_attr_val fl">{{val.name}}</div>
              </div>
            </div>
          </div>
          <div v-if="relationGoods.length" class="pc_goods_detail_right_relation_goods clearfix_">
            <div class="fl pc_goods_detail_right_score_change_title">关联商品：</div>
            <div class="fl pc_goods_detail_right_relation_goods_list clearfix_">
              <div @click="gotoGoodsDetail(item)" v-for="(item,index) in relationGoods" :key="index" class="pc_goods_detail_right_relation_goods_item fl clearfix_">
                <div class="pc_goods_detail_right_relation_goods_item_img fl"><img :src="item.pic?item.pic:noImg" alt=""></div>
                <div class="pc_goods_detail_right_relation_goods_item_name fl">{{item.name}}</div>
              </div>
            </div>
          </div>
          <div class="pc_goods_detail_right_num_box clearfix_">
            <div class="fl pc_goods_detail_right_score_change_title">数量：</div>
            <div class="fl pc_goods_detail_right_num clearfix_">
              <div @click="changeGoodsNum(1)" class="fl pc_goods_detail_right_num_reduce">-</div>
              <div class="fl pc_goods_detail_right_num_input"><input @blur="changeGoodsNum(3)" v-model="buyNum" type="number"></div>
              <div @click="changeGoodsNum(2)" class="fl pc_goods_detail_right_num_plus">+</div>
            </div>
          </div>
          <div class="pc_goods_detail_right_btn_box clearfix_">
            <div @click="spellTeamActive" v-if="spellGroupList.length" class="fl pc_goods_detail_right_btn_team">我要开团</div>
            <div @click="addShoppFn1('加入购物车')" :class="{'pc_goods_detail_right_btn_add_active':prohibitBuyGoods}" class="fl pc_goods_detail_right_btn_add">加入购物车</div>
            <div @click="addShoppFn1('立即购买')" :class="{'pc_goods_detail_right_btn_buy_active':prohibitBuyGoods}" class="fl pc_goods_detail_right_btn_buy">立即购买</div>
          </div>
        </div>
      </div>




      <div v-show="alreadyHaveSpellTeam" class="participate_team">
        <div class="participate_team_title clearfix_">
          <p class="fl">{{alreadyHaveSpellTeamToatl}}个团正在拼单，可直接参与</p>
          <p @click="moreSpellTeamFn" class="fr participate_team_title_more">更多</p>
        </div>
        <div>
          <div v-for="(item,index) in alreadyHaveSpellTeamList" :key="index" class="participate_team_list clearfix_"> 
            <div class="fl participate_team_list_num">
              <div class="team_list_box" ref="team_list_box">
                <ul class="team_list clearfix_" ref="team_list">
                  <li class="fl" v-for="(val,idx) in item.memberData" :key="idx">
                    <p class="team_item" v-show="val"><img :src="val.iconImg?val.iconImg:people" alt=""></p>
                    <p class="team_item" v-show="!val">?</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="fl clearfix_">
              <div class="participate_team_attribute fl">
                <p class="participate_team_attr">{{item.goodsUnitName}} {{item.property1}}</p>
                <p class="participate_team_time">还差 <span>{{item.returnNum}}</span> 人拼成，剩余时间： <i style="display: inline-block;width: 100px;text-align: right;">{{item.endTime}}</i></p>
              </div>
              <div class="fl participate_team_btn">
                <div v-show="item.type==1" :class="{active:item.type==1}">参与拼单</div>
                <div v-show="item.type!=1" @click="partakeSpellTeam(item.promotionSpellGroupItemId,item.id)">参与拼单</div>
              </div>
            </div>
          </div>
        </div>
      </div>




      <div class="pc_goods_detail_goods_img_box clearfix_">
        <div class="fl pc_goods_left">
          <div class="pc_goods_left_title">最新销售</div>
          <div class="pc_goods_left_list">
            <div @click="gotoGoodsDetail(item)" v-for="(item,index) in goodsLeftList" :key="index" class="pc_goods_left_item">
              <div class="pc_goods_left_item_img"><img :src="item.goodsHeadpicPath1?item.goodsHeadpicPath1:noImg" alt=""></div>
              <div class="pc_goods_left_item_name">{{item.name}}</div>
              <div class="pc_goods_left_item_price">¥{{item.price}}</div>
            </div>
          </div>
        </div>
        <div ref="getHeight" id="searchBar" class="fr pc_goods_detail_goods_right">
          <div :class="titleFixed?'isFixed':''" class="pc_goods_detail_goods_right_title clearfix_">
            <div @click="goodsDescFn" :class="{'pc_goods_detail_goods_right_title_item_active':titleActive=='desc'}" class="fl pc_goods_detail_goods_right_title_item">商品详情</div>
            <div @click="morePropertyData" :class="{'pc_goods_detail_goods_right_title_item_active':titleActive=='property'}" class="fl pc_goods_detail_goods_right_title_item">包装及参数</div>
            <div @click="getGoodsEvaluation" :class="{'pc_goods_detail_goods_right_title_item_active':titleActive=='evaluation'}" class="fl pc_goods_detail_goods_right_title_item">评论</div>
          </div>
          <div class="pc_goods_detail_goods_right_attr_box">
            <div v-show="titleActive=='desc'" class="pc_goods_detail_goods_right_attr">
              <div class="pc_goods_detail_goods_right_attr_list clearfix_">
                <div class="pc_goods_detail_goods_right_attr_item fl">品牌：{{goodsData.brandName}}</div>
                <div v-for="(item,index) in goodsData.propertyData" :key="index" class="pc_goods_detail_goods_right_attr_item fl">{{item.name}}：<span v-for="(val,idx) in item.attribute_val" :key="idx">{{val.name}} </span></div>
              </div>
              <div @click="morePropertyData" class="pc_goods_detail_goods_right_attr_more">更多参数及包装>></div>
            </div>
            <div class="pc_goods_detail_goods_right_img_box">
              <div v-show="titleActive=='desc'" v-html="v_html1" class="pc_goods_detail_goods_right_img"></div>
              <div v-show="titleActive=='property'" v-html="v_html2" class="pc_goods_detail_goods_right_img"></div>
              <div v-show="titleActive=='property'" v-html="v_html3" class="pc_goods_detail_goods_right_img"></div>
              <div v-show="titleActive=='evaluation'" class="pc_goods_detail_goods_right_img">
                <div v-for="(item,index) in evaluationList" :key="index" class="pc_goods_detail_evaluation_item clearfix_">
                  <div class="fl pc_goods_detail_evaluation_member clearfix_">
                    <div class="fl pc_goods_detail_evaluation_member_ico"><img :src="item.member.ico" alt=""></div>
                    <div class="fl pc_goods_detail_evaluation_member_name">{{item.member.name}}</div>
                  </div>
                  <div class="fr pc_goods_detail_evaluation_txt_box">
                    <div class="clearfix_">
                      <el-rate class="fl" v-model="item.level" disabled text-color="#ff9900"></el-rate>
                      <div class="fr pc_goods_detail_evaluation_txt_time">{{item.dateCreated}}</div>
                    </div>
                    <div class="pc_goods_detail_evaluation_txt_remark">{{item.evaluationContent}}</div>
                    <div v-show="item.pic1.length" class="pc_goods_detail_evaluation_txt_pic clearfix_">
                      <div v-for="(val,idx) in item.pic1" :key="idx" class="fl pc_goods_detail_evaluation_txt_pic_item"><img :src="val" alt=""></div>
                    </div>
                    <div style="margin-bottom:10px;" v-show="item.type==1">
                      <div class="pc_goods_detail_evaluation_txt_add">买家追评</div>
                      <div class="pc_goods_detail_evaluation_txt_add_remark">{{item.secondEvaluationContent}}</div>
                      <div v-show="item.pic2.length" class="pc_goods_detail_evaluation_txt_pic clearfix_">
                        <div v-for="(val,idx) in item.pic2" :key="idx" class="fl pc_goods_detail_evaluation_txt_pic_item"><img :src="val" alt=""></div>
                      </div>
                    </div>
                    <div v-show="item.sellerEvaluationContent" class="pc_goods_detail_evaluation_txt_add_reply">商家回复：{{item.sellerEvaluationContent}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="maskShow" class="pc_goods_detail_mask">
      <div v-show="addShoppSuccessShow" class="pc_goods_detail_add_success">
        <div class="pc_goods_detail_add_success_title">温馨提示</div>
        <div class="pc_goods_detail_add_success_content clearfix_">
          <div class="fl pc_goods_detail_add_success_content_txt clearfix_">
            <div class="fl pc_goods_detail_add_success_content_img"><img src="http://img.source.9188cn.com/pc_goods_detail_yes.png" alt=""></div>
            <div class="fl pc_goods_detail_add_success_content_text">已成功加入购物车</div>
          </div>
          <div @click="gotoCart" class="fl pc_goods_detail_add_success_content_btn">去购物车结算</div>
        </div>
      </div>
      <div v-show="spellTeamShow" class="pc_goods_detail_team">
        <div class="pc_goods_detail_team_price_box">
          <div class="pc_goods_detail_team_price clearfix_"><span class="fl">拼团价格：</span><i class="fl">{{spellTeamPrice}}</i></div>
          <div class="pc_goods_detail_team_discount">团长再优惠¥{{spellTeamPriceDiscount}}元（可领取礼包）</div>
        </div>
        <div class="pc_goods_detail_team_attr clearfix_">
          <div @click="changeSpellTeamItem(item)" :class="item.isChecked?'pc_goods_detail_team_attr_item_active':''" v-for="(item,index) in spellGroupList" :key="index" class="pc_goods_detail_team_attr_item fl"><span v-if="item.property1">{{item.property1}}，</span><span v-if="item.goodsUnitName">{{item.goodsUnitName}}</span><span v-if="item.num"> + {{item.val}}人</span></div>
        </div>
        <div class="pc_goods_detail_team_num_box clearfix_">
          <div class="fl pc_goods_detail_team_num_title">数量：</div>
          <div class="fl pc_goods_detail_team_num clearfix_">
            <div @click="changeSpellTeamNum(1)" class="fl pc_goods_detail_right_num_reduce">-</div>
            <div class="fl pc_goods_detail_right_num_input"><input @blur="changeSpellTeamNum(3)" v-model="spellTeamNum" type="number"></div>
            <div @click="changeSpellTeamNum(2)" class="fl pc_goods_detail_right_num_plus">+</div>
          </div>
        </div>
        <div class="change_spell_team">{{isChangeSpellTeam?'已更改参与拼团，是否重新开团':''}}</div>
        <div class="pc_goods_detail_team_btn_box clearfix_">
          <div @click="confirmSpellTeam" class="fl pc_goods_detail_team_btn">确认</div>
          <div @click="spellTeamHide" class="fl pc_goods_detail_team_btn">取消</div>
        </div>
      </div>
      <div v-show="moreSpellTeam" class="more_team">
        <div style="height: 400px;overflow-y: auto;">
          <div v-for="(item,index) in alreadyHaveSpellTeamList" :key="index" style="width:1100px;margin:0 auto;padding-top:20px;" class="participate_team_list clearfix_"> 
          <!-- <div class="participate_team_list clearfix_"> -->
            <div style="width:650px;" class="fl participate_team_list_num">
              <div class="team_list_box" ref="team_list_box">
                <ul class="team_list clearfix_" ref="team_list">
                  <li class="fl" v-for="(val,idx) in item.memberData" :key="idx">
                    <p class="team_item" v-show="val"><img :src="val.iconImg?val.iconImg:people" alt=""></p>
                    <p class="team_item" v-show="!val">?</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="fl clearfix_">
              <div class="participate_team_attribute fl">
                <p class="participate_team_attr">{{item.goodsUnitName}} {{item.property1}}</p>
                <p class="participate_team_time">还差 <span>{{item.returnNum}}</span> 人拼成，剩余时间： <i style="display: inline-block;width: 100px;text-align: right;">{{item.endTime}}</i></p>
              </div>
              <div class="fl participate_team_btn">
                <div v-show="item.type==1" :class="{active:item.type==1}">参与拼单</div>
                <div v-show="item.type!=1" @click="partakeSpellTeam(item.promotionSpellGroupItemId,item.id)">参与拼单</div>
              </div>
            </div>
          </div>
        </div>
        <div class="more_team_btn">
          <div @click="offMoreSpellTeam">取消</div>
        </div>
      </div>
      <div v-show="scanCodeShow" class="pc_goods_detail_qrCode_box">
        <div class="pc_goods_detail_qrCode_img"><img :src="scanCodeImg" alt=""></div>
        <div @click="scanCodeHide" class="pc_goods_detail_qrCode_btn">×</div>
      </div>
    </div>
    <pcBackTop></pcBackTop>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import PicZoom from 'vue-piczoom'
import { ip,overtime } from '../../assets/js/public.js'
import pcHeader from '@/components/index/search'
import pcBackTop from '@/components/common/BackTop'
export default {
  data(){
    return {
      noImg:require("@/assets/img/aa.png"),
      people:require('../../assets/img/people.png'),
      categoryStr:[],
      goodsImgList:[],
      bigImg:'',
      goodsData:{},
      goodsTxtData:[],
      shareShow:false,
      salesGoodsPageSize:1,
      goodsLeftList:[],
      collectionId:[],
      isAjax:true,
      scanCodeImg:'',
      maskShow:false,
      scanCodeShow:false,
      spellGroupData:{},
      spellGroupList:[],
      spellTeamShow:false,
      spellTeamPrice:'',
      spellTeamPriceDiscount:'',
      spellTeamId:'',
      eachOrderLimitNum:null,
      allLimitNum:null,
      memberLimitNum:null,
      spellTeamNum:1,
      goodsPromotionList:[],
      moreGoodsPromotion:false,
      moreOtherPromotion:false,
      otherPromotionList:[],
      scoreGoodsList:[],
      prohibitBuyGoods:false,
      buyGoodsIds:'',
      allGoodsNum:0,
      onlyUnitId:'',
      buyNum:1,
      addShoppSuccessShow:false,
      prohibitChangeAttr:false,
      relationGoods:[],
      couponList:[],
      couponMore:true,
      alreadyHaveSpellTeam:false,
      alreadyHaveSpellTeamToatl:0,
      alreadyHaveSpellTeamList:[],
      timer:null,
      moreSpellTeam:false,
      oldSellTeamId:'',
      isChangeSpellTeam:false,
      attendSpellTeam:false,
      partakeSpellTeamId:'',
      v_html1:'',
      v_html2:'',
      v_html3:'',
      titleFixed:false,
      titleActive:'desc',
      evaluationList:[]
    }
  },
  components:{
    pcHeader,pcBackTop,PicZoom
  },
  mounted:function(){
    var t_=this
    fn()
    function fn(){
      setTimeout(()=>{
        if(Math.floor(t_.$refs.getHeight.offsetHeight/272)==0){
          fn()
        }else{
          t_.salesGoodsPageSize=Math.floor(t_.$refs.getHeight.offsetHeight/272)
          t_.salesGoods()
        }
      },50,t_)
    }
    setTimeout(() => {
      window._bd_share_config = {
        common : {
          bdText : '',
          bdDesc : '',
          bdPic : '',
        },
        share : [{
          tag:"share_0",
          bdSize : 24
        }],
      };
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5);
      document.body.appendChild(s);
    },200)
    t_.getMallGoodsById()
    t_.getPromotionDataForDetail()
    t_.scoreChangeList()
    document.addEventListener('scroll', t_.handleScroll)
  },
  methods:{
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      return window.open(href.href,'_blank')
    },
    goSignIn:function(){
      localStorage.removeItem('tamp')
      localStorage.removeItem('name')
      return this.$router.push({
        name: 'loginHome',
        query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
      });
    },
    gotoGoodsDetail:function(item){
      var href=this.$router.resolve({name:'goodsdetails',query:{goodsId:item.goodsId,supplyChainTenantId:item.supplyChainTenantId,isSupplyChainGoods:2}})
      return window.open(href.href,'_blank')
    },
    gotoCategory:function(id){
      var href=this.$router.resolve({name:'goodslist',query:{id:id}})
      return window.open(href.href,'_blank')
    },
    gotoIndex:function(){
      this.$router.push({
        name: 'home'
      })
    },
    gotoCart:function(){
      var href=this.$router.resolve({name:'shopCar'})
      window.open(href.href,'_blank')
    },
    getGoodsEvaluation:function(){
      var t_=this
      t_.titleActive='evaluation'
      var data0bj={
        goodsId:t_.goodsTxtData.goodsId,
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:1,
        pagesize:10
      }
      axios.post(`${ip}formWorkInterface/getEvaluation`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.evaluationList=res.data.evaluationcontent
        }
      })
    },
    handleScroll:function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let offsetTop = document.querySelector('#searchBar').offsetTop;
      if (scrollTop > offsetTop) {
        this.titleFixed = true
      } else {
        this.titleFixed = false
      }
    },
    goodsDescFn:function(){
      this.titleActive='desc'
    },
    morePropertyData:function(){
      this.titleActive='property'
    },
    shareGoods:function(){
      this.shareShow=!this.shareShow
    },
    changBigImg:function(src){
      this.bigImg=src
    },
    changeScoreGoodsItem:function(item){
      var t_=this
      if(item.isChecked){
        item.isChecked=false
        t_.prohibitChangeAttr=false
        t_.changeScoreGoodsUnitId=''
        t_.changeScoreGoodsAttr=''
        t_.changeScoreGoodsId=''
      }else{
        t_.scoreGoodsList.forEach(function(val,idx){
          val.isChecked=false
        })
        item.isChecked=true
        t_.prohibitChangeAttr=true
        t_.changeScoreGoodsUnitId=item.goodsUnitId
        t_.changeScoreGoodsAttr=item.property2
        t_.changeScoreGoodsId=item.promotionIds
        // t_.prohibitBuyGoods=false
      }
    },
    scoreChangeList:function(){
      var t_=this
      var data0bj={
        goodsId:t_.$route.query.goodsId,
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      axios.post(`${ip}formWorkInterface/scoreChangeList`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          res.data.data.forEach(function(item,index){
            t_.$set(item,'isChecked', false)
          })
          t_.scoreGoodsList=res.data.data
        }
      })
    },
    getOtherPromotionData:function(){
      var t_=this
      if(t_.moreOtherPromotion){
        t_.moreOtherPromotion=false
        t_.otherPromotionList=[]
      }else{
        var data0bj=Qs.stringify({
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          goodsId:t_.goodsTxtData.goodsId,
          supplyChainTenantId:t_.goodsTxtData.supplyChainTenantId
        })
        axios.post(`${ip}formWorkInterface/getPromotionDataForDetail`,data0bj).then(res=>{
          if(overtime(res.data.code))return t_.goSignIn()
          if(res.data.code==300)return t_.go404(res.data.message)
          if(res.data.code==0){
            t_.otherPromotionList=res.data.data
            t_.moreOtherPromotion=true
          }
        })
      }
    },
    moreGoodsPromotionFn:function(){
      this.moreGoodsPromotion=!this.moreGoodsPromotion
    },
    changeGoodsNum:function(type){
      var t_=this
      if(type==1){
        if(t_.buyNum<=1)return
        t_.buyNum--
      }else if(type==2){
        if(t_.buyNum>200)return
        t_.buyNum++
      }else if(type==3){
        if(t_.buyNum<1||t_.buyNum>200)t_.buyNum=1
      }
    },
    changeSpellTeamNum:function(type){
      var t_=this
      if(type==1){
        if(t_.spellTeamNum<=1)return
        t_.spellTeamNum--
      }else if(type==2){
        if(t_.spellTeamNum>200)return
        t_.spellTeamNum++
      }else if(type==3){
        if(t_.spellTeamNum<1||t_.spellTeamNum>200)t_.spellTeamNum=1
      }
    },
    partakeSpellTeam:function(promotionSpellGroupItemId,id){
      var t_=this
      t_.maskShow=true
      t_.moreSpellTeam=false
      t_.spellTeamShow=true
      t_.attendSpellTeam=true
      t_.oldSellTeamId=promotionSpellGroupItemId
      t_.partakeSpellTeamId=id
      t_.spellGroupList.forEach(function(item,index){
        item.isChecked=false
        if(promotionSpellGroupItemId==item.id){
          item.isChecked=true
          t_.spellTeamPrice=item.price
          t_.spellTeamPriceDiscount=parseInt(item.price)-parseInt(item.headPrice)
          t_.spellTeamId=item.id
          t_.eachOrderLimitNum=item.num
          t_.allLimitNum=item.limitNum
          t_.memberLimitNum=item.memberNum
        }
      })
    },
    changeSpellTeamItem:function(item){
      var t_=this
      if(item.isChecked){
        item.isChecked=false
        t_.spellTeamPrice='--'
        t_.spellTeamPriceDiscount='--'
        t_.spellTeamId=''
        t_.eachOrderLimitNum=null
        t_.allLimitNum=null
        t_.memberLimitNum=null
      }else{
        if(t_.oldSellTeamId&&(t_.oldSellTeamId!=item.id)){
          t_.isChangeSpellTeam=true
        }else{
          t_.isChangeSpellTeam=false
        }
        t_.spellGroupList.forEach(function(val,idx){
          val.isChecked=false
        },t_)
        item.isChecked=true
        t_.spellTeamPrice=item.price
        t_.spellTeamPriceDiscount=parseInt(item.price)-parseInt(item.headPrice)
        t_.spellTeamId=item.id
        t_.eachOrderLimitNum=item.num
        t_.allLimitNum=item.limitNum
        t_.memberLimitNum=item.memberNum
      }
    },
    confirmSpellTeam:function(){
      var t_=this
      if(!t_.spellTeamId)return t_.$message({
        message:'选择属性后才能开团哦~！',
        center:true,
        type:'warning'
      })
      var fal=1
      if(t_.eachOrderLimitNum!='不限购'&&t_.eachOrderLimitNum<t_.spellTeamNum){
        fal=0
        return t_.$message({
          message:'已超限购量~！',
          center:true,
          type:'warning'
        })
      }
      if(t_.allLimitNum!='不限购'&&t_.allLimitNum<t_.spellTeamNum){
        fal=0
        return t_.$message({
          message:'已超限购量~！',
          center:true,
          type:'warning'
        })
      }
      if(t_.memberLimitNum!='不限购'&&t_.memberLimitNum<t_.spellTeamNum){
        fal=0
        return t_.$message({
          message:'已超限购量~！',
          center:true,
          type:'warning'
        })
      }
      if(fal==1){
        var status=0,confirmTeamId=''
        if(t_.attendSpellTeam){
          if(t_.isChangeSpellTeam){
            status=1
            confirmTeamId=t_.spellTeamId
          }else{
            status=2
            confirmTeamId=t_.partakeSpellTeamId
          }
        }else{
          status=1
          confirmTeamId=t_.spellTeamId
        }
        var href=this.$router.resolve({name:'settlement',query:{confirmTeamId:confirmTeamId,status:status,num:t_.spellTeamNum}})
        return window.open(href.href,'_blank')
      }
    },
    spellTeamHide:function(){
      this.maskShow=false
      this.spellTeamShow=false
    },
    spellTeamActive:function(){
      var t_=this
      if(t_.goodsData.isShow==0)return t_.$message({
        message:'该商品暂时不能拼团~！',
        center:true,
        type:'warning'
      })
      if(t_.spellGroupList.length){
        t_.maskShow=true
        t_.spellTeamShow=true
        t_.spellGroupList.forEach(function(item,index){
          item.isChecked=false
        })
        t_.spellGroupList[0].isChecked=true
        t_.spellTeamPrice=t_.spellGroupList[0].price
        t_.spellTeamPriceDiscount=parseInt(t_.spellGroupList[0].price)-parseInt(t_.spellGroupList[0].headPrice)
        t_.spellTeamId=t_.spellGroupList[0].id
        t_.eachOrderLimitNum=t_.spellGroupList[0].num
        t_.allLimitNum=t_.spellGroupList[0].limitNum
        t_.memberLimitNum=t_.spellGroupList[0].memberNum
      }
    },
    scanCodeHide:function(){
      this.scanCodeShow=false
      this.maskShow=false
    },
    scanCodeByPhone:function(){
      var t_=this
      if(t_.isAjax){
        var data0bj = {
          goodsId:t_.$route.query.goodsId,
          channel: 2,
          tamp:localStorage.tamp?localStorage.tamp:''
        }
        axios.post(`${ip}formWorkInterface/getXcxQrcode`,Qs.stringify(data0bj)).then(res => {
          if(overtime(res.data.code))return t_.goSignIn()
          if(res.data.code==300)return t_.go404(res.data.message)
          if(res.data.code == 0){
            t_.scanCodeImg = `${ip}${res.data.url}`
            t_.isAjax=false
            t_.maskShow=true
            t_.scanCodeShow=true
          }
        })
      }else{
        t_.scanCodeShow=true
      }
    },
    receiveCoupon:function(id,n){
      var t_=this
      if(n==0)return t_.$message({
        message:'不能太贪心哦~!',
        center:true,
        type:'warning'
      })
      var data0bj=Qs.stringify({
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        id:id
      })
      axios.post(`${ip}formWorkInterface/bondCoupon`,data0bj).then(res =>{
          if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.couponList.forEach(function(item,index){
            if(item.id==res.data.id)item.count=res.data.num
          })
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    getPromotionCouponRuleList:function(){
      var t_=this
      var data0bj = {
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        status:1,
        goodsId:t_.goodsTxtData.goodsId
      }
      axios.post(`${ip}formWorkInterface/getPromotionCouponRuleList`,Qs.stringify(data0bj)).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.couponList=res.data.promotionCouponRuleRs
        }
      })
    },
    offMoreSpellTeam:function(){
      this.maskShow=false
      this.moreSpellTeam=false
    },
    moreSpellTeamFn:function(){
      this.maskShow=true
      this.moreSpellTeam=true
    },
    spellGroupOrder:function () {
      var t_=this
      let data = Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.goodsId
      });
      axios.post(`${ip}spellGroupInterface/spellGroupOrder`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          if(res.data.data.total){
            t_.alreadyHaveSpellTeam=true
            t_.alreadyHaveSpellTeamToatl=res.data.data.total
            res.data.data.data.forEach(function(item,index){
              t_.$set(item,'endTime', '')
            },t_)
            res.data.data.data.forEach(function (item, index) {
              t_.timer = setInterval(()=>{
                if (item.l){
                  item.endTime = t_.getTimeLeft(item.l)
                  item.l = item.l - 1000
                  if (item.l == "0小时 0分 0秒") {
                    clearInterval(t_.timer);
                  }
                }
              }, 1000);
            })
            t_.alreadyHaveSpellTeamList=res.data.data.data
          }
        }
      })
    },
    getPromotionDataForDetail:function(){
      var t_=this
      var data0bj = {
        id:t_.$route.query.goodsId,
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      axios.post(`${ip}spellGroupInterface/getPromotionDataForDetail`,Qs.stringify(data0bj)).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          res.data.data.forEach(function(item,index){
            t_.$set(item,'isChecked', false)
          })
          t_.spellGroupData=res.data
          t_.spellGroupList=res.data.data
        }
      })
    },
    collectionGoods:function(){
      var t_=this
      var data={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      if(t_.goodsData.isCollection==1){
        var url=`${ip}formWorkInterface/deteleCollection`
        data.id=JSON.stringify(t_.collectionId)
      }else if(t_.goodsData.isCollection==2){
        var url=`${ip}formWorkInterface/addCollection`
        data.goodsId=t_.$route.query.goodsId
      }
      axios.post(url,Qs.stringify(data)).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code == 0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          if(t_.goodsData.isCollection==1){
            t_.goodsData.isCollection=2
          }else if(t_.goodsData.isCollection==2){
            t_.collectionId.push(res.data.id)
            t_.goodsData.isCollection=1
          }
        }else {
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    changeAttrVal:function(index,idx){
      var t_=this
      if(t_.prohibitChangeAttr)return
      if(t_.goodsData.attributes[index].attribute_val[idx].isChecked){
        t_.goodsData.attributes[index].attribute_val[idx].isChecked=false
      }else{
        for(var i=0;i<t_.goodsData.attributes[index].attribute_val.length;i++){
          t_.goodsData.attributes[index].attribute_val[i].isChecked = false;
        }
        t_.goodsData.attributes[index].attribute_val[idx].isChecked=true
      }
      var sid=''
      if(t_.onlyUnitId)sid+=t_.onlyUnitId+'|'
      t_.goodsData.attributes.forEach(function(item,index){
        item.attribute_val.forEach(function(val,idx){
          if(val.isChecked)sid+=val.sid+'|'
        })
      })
      sid = sid.substring(0, sid.length - 1)
      for(var i=0;i<t_.goodsData.quotationItem.length;i++){
        if(sid==t_.goodsData.quotationItem[i].group){
          t_.goodsTxtData.price==t_.goodsData.quotationItem[i].price
          t_.buyGoodsIds=t_.goodsData.quotationItem[i].group
          t_.allGoodsNum=t_.goodsData.quotationItem[i].num
          t_.prohibitBuyGoods=false
          break
        }else{
          t_.prohibitBuyGoods=true
        }
      }
    },
    addShoppFn1:function(btn){
      var t_=this
      if(!localStorage.tamp)return t_.goSignIn()
      if(t_.goodsData.isShow==0)return t_.$message({
        message:btn=='立即购买'?'该商品暂时不能立即购买~！':'该商品暂时不能加入购物车~！',
        center:true,
        type:'warning'
      })
      if(t_.prohibitBuyGoods)return t_.$message({
        message:btn=='立即购买'?'选择属性才能购买哦~！':'选择属性才能加入购物车哦~！',
        center:true,
        type:'warning'
      })
      if(t_.buyNum>t_.allGoodsNum){
        if(t_.goodsData.flash==2){
          t_.addShoppFn2(btn)
        }else{
          return t_.$message({
            message:'超出库存数量~！',
            center:true,
            type:'warning'
          })
        }
      }else{
        t_.addShoppFn2(btn)
      }
    },
    addShoppFn2:function(btn){
      var t_=this
      if(t_.buyNum>200)return t_.$message({
        message:'购买数量不可超过200哦~！',
        center:true,
        type:'warning'
      })
      var data={
        num: t_.buyNum,
        goodsId:t_.goodsTxtData.goodsId,
        type: 1,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        supplyChainTenantId:t_.goodsTxtData.supplyChainTenantId
      }
      if(t_.onlyUnitId){
        data.goodsUnitId=t_.onlyUnitId
      }else{
        data.goodsUnitId=t_.buyGoodsIds.split('|')[0];
      }
      if(t_.buyGoodsIds){
        var property2=''
        for(var i=1;i<t_.buyGoodsIds.split('|').length;i++){
          property2+='|'+t_.buyGoodsIds.split('|')[i]
        }
        property2+='|'
      }
      data.property2=property2=='|'?'':property2
      if(t_.prohibitChangeAttr){
        data.goodsUnitId=t_.changeScoreGoodsUnitId
        data.property2=t_.changeScoreGoodsAttr
        data.promotionIds=t_.changeScoreGoodsId
        data.type=3
        data.usescore=3
      }
      if(btn=='立即购买')var url=`${ip}formWorkInterface/immediatePayment`
      if(btn=='加入购物车')var url=`${ip}formWorkInterface/addShopping`
      axios.post(url,Qs.stringify(data)).then(res=>{
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if( res.data.code == 0 ){
          if(btn=='立即购买'){
            var href=t_.$router.resolve({name:'settlement',query:{ids: res.data.cartIds,type:1}})
            window.open(href.href,'_blank')
          }else{
            t_.addShoppSuccessShow = true
            t_.maskShow=true
            t_.$store.commit('ccc')
            setTimeout(()=>{
              t_.addShoppSuccessShow=false
              t_.maskShow=false
            },3000,t_)
          }
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    getMallGoodsById:function () {
      var t_=this
      let data = Qs.stringify({
        goodsId: t_.$route.query.goodsId,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        isSupplyChainGoods:t_.$route.query.isSupplyChainGoods?t_.$route.query.isSupplyChainGoods:'',
        supplyChainTenantId:t_.$route.query.supplyChainTenantId?t_.$route.query.supplyChainTenantId:''
      });
      axios.post(`${ip}formWorkInterface/getMallGoodsById`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.categoryStr=res.data.rows.categoryData
          if(res.data.pic.length)this.bigImg=res.data.pic[0]
          t_.goodsData=res.data.rows
          t_.goodsTxtData=res.data.rows.goods
          t_.v_html1=t_.goodsTxtData.goodsDesc
          t_.v_html2=t_.goodsTxtData.goodsParam
          t_.v_html3=t_.goodsTxtData.goodsPack
          t_.getPromotionCouponRuleList()
          t_.goodsImgList=res.data.pic
          t_.goodsPromotionList=res.data.rows.promotionData
          res.data.rows.recommendList.forEach(function(item,index){
            t_.$set(item,'goodsId', item.id)
          })
          t_.relationGoods=res.data.rows.recommendList
          if(res.data.rows.isShow==0){
            t_.prohibitBuyGoods=true
          }
          if(res.data.rows.unitData.length>1){
            var obj={
              name:'单位',
              attribute_val:[]
            }
            res.data.rows.unitData.forEach((item,index)=>{
              item.sid=item.id
              obj.attribute_val.push(item)
            })
            res.data.rows.attributes.unshift(obj)
            t_.prohibitBuyGoods=true
          }else{
            t_.onlyUnitId=res.data.rows.unitData[0].id
            res.data.rows.quotationItem.forEach(function(item,index){
              if(t_.onlyUnitId==item.group){
                t_.goodsTxtData.price=item.price
                t_.buyGoodsIds=item.group
                t_.allGoodsNum=item.num
                t_.prohibitBuyGoods=false
              }else{
                t_.prohibitBuyGoods=true
              }
            })
          }
          res.data.rows.attributes.forEach(function(item,index){
            item.attribute_val.forEach(function(val,idx){
              t_.$set(val,'isChecked', false)
            })
          })
          t_.attributeList=res.data.rows.attributes
          if(localStorage.tamp){
            t_.addFootPrint()
            t_.spellGroupOrder()
          }
        }
      })
    },
    addFootPrint:function(){
      var data0bj = {
        goodsId:this.$route.query.goodsId,
        channel: 2,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      axios.post(`${ip}formWorkInterface/addFootPrint`,Qs.stringify(data0bj))
      .then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
      })
    },
    salesGoods:function () {
      var t_=this
      var data = {
        channel:2,
        pagesize:t_.salesGoodsPageSize,
        page:1,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      if(t_.$route.query.id)data.categoryId=t_.$route.query.id
      if(t_.$route.query.goodsId)data.goodsId=t_.$route.query.goodsId
      data=Qs.stringify(data)
      axios.post(`${ip}formWorkInterface/salesGoods`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.goodsLeftList = res.data.results.rows
        }
      })
    },
    getTimeLeft:function(mss){
      let hours = parseInt(mss / (1000 * 60 * 60));
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      return  hours + "小时 " + minutes + "分 " + seconds + '秒'
    },
  }
}
</script>
<style>
.pc_goods_detail_box{
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 50px;
}
.pc_goods_list_nav{
  width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin-bottom: 20px;
}
.pc_goods_list_nav_item{
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.pc_goods_list_nav_item:last-child span{
  display: none;
}
.pc_goods_detail_content{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.pc_goods_detail_left{
  width: 360px;
}
.pc_goods_detail_left_pic{
  width: 360px;
  height: 360px;
  margin-bottom: 10px;
  position: relative;
}
.mouse-cover-canvas{
  position: absolute;
  top: 279px !important;
  left: 730px !important;
  z-index: 999;
}
.pc_goods_detail_activity{
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
.pc_goods_detail_activity_img{
  width: 100%;
}
.pc_goods_detail_activity_img img{
  width: 100%;
}
.pc_goods_detail_activity_txt{
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pc_goods_detail_left_img_box{
  height: 60px;
  position: relative;
  margin-bottom: 10px;
}
.pc_goods_detail_left_img_prev,.pc_goods_detail_left_img_next{
  width: 26px;
  height: 26px;
  background:url(../../assets/img/next_.png);
  cursor: pointer;
  position: absolute;
  top: 21px;
  right: -25px;
}
.pc_goods_detail_left_img_prev{
  background:url(../../assets/img/prev_.png);
  left: -25px;
}
.pc_goods_detail_left_img_list_box{
  width: 360px;
  height: 55px;
  overflow: hidden;
}
.pc_goods_detail_left_img_item{
  width: 53px;
  height: 53px;
  border: 1px solid transparent;
  margin-right: 6px;
  cursor: pointer;
}
.pc_goods_detail_left_img_item:hover{
  border: 1px solid #e00;
}
.pc_goods_detail_left_img_item:last-child{
  margin-right: 0;
}
.pc_goods_detail_left_img_item img{
  width: 53px;
  height: 53px;
}
.pc_goods_detail_right{
  width: 560px;
  margin-left: 15px;
}
.pc_goods_detail_right_name1{
  width: 560px;
  padding: 8px 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #2c3e50;
}
.pc_goods_detail_right_name2{
  width: 560px;
  line-height: 20px;
  padding: 8px 0;
  font-size: 16px;
  color: #f12002;
}
.pc_goods_detail_right_txt_box{
  padding-left: 10px;
  background: #f3f3f3;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.pc_goods_detail_right_team{
  height: 22px;
  background:#fa0;
  padding: 10px 5px;
  margin-left: -10px;
  color:#fff;
  opacity: .8;
}
.pc_goods_detail_right_team span{
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 5px;
  font-size:14px;
  width: 70px;
}
.pc_goods_detail_right_team i{
  font-size: 22px;
}
.pc_goods_detail_right_price{
  padding: 10px 0;
}
.pc_goods_detail_right_price_txt{
  font-size: 12px;
  width: 70px;
  line-height: 22px;
  color:#999;
}
.pc_goods_detail_right_price_num1{
  text-align: center;
  font-size: 22px;
  color: #f60;
}
.pc_goods_detail_right_price_num2{
  height: 22px;
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  text-decoration: line-through;
  margin-left: 30px;
}
.pc_goods_detail_right_coupon{
  margin-bottom: 10px;
}
.pc_goods_detail_right_coupon_item{
  margin-bottom: 10px;
}
.pc_goods_detail_right_coupon_item:last-child{
  margin-bottom: 0;
}
.pc_goods_detail_right_coupon_item_price{
  width: 63px;
  height: 19px;
  background: url('http://img.source.9188cn.com/pc_goods_detail_coupon.png');
  background-size: 100%;
  text-align: center;
  line-height: 19px;
  color:#f12002;
  margin-right: 15px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin-top: 2px;
}
.pc_goods_detail_right_coupon_item_txt{
  width: 250px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  line-height: 22px;
  margin-right: 15px;
}
.pc_goods_detail_right_coupon_item_btn{
  width: 50px;
  height: 17px;
  text-align: center;
  line-height: 17px;
  border-radius: 5px;
  border: 1px solid #f12002;
  color:#f12002;
  cursor: pointer;
  margin-top: 2px;
}
.pc_goods_detail_right_coupon_item_btn_active{
  border:1px solid #d7d7d7;
  color:#d7d7d7;
}
.pc_goods_detail_right_coupon_list{
  width: 440px;
  overflow: hidden;
}
.pc_goods_detail_right_coupon_more{
  line-height: 22px;
  cursor: pointer;
}
.pc_goods_detail_right_goods_promotion_item{
  margin-bottom: 10px;
}
.pc_goods_detail_right_goods_promotion_item:last-child{
  margin-bottom: 0;
}
.pc_goods_detail_right_goods_promotion_item_title{
  color:#e00;
  border: 1px solid #e00;
  height: 12px;
  padding: 4px 3px;
  margin-right: 5px;
}
.pc_goods_detail_right_goods_promotion_item_txt{
  overflow: hidden;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width:330px;
  cursor: pointer;
}
.pc_goods_detail_right_goods_promotion{
  margin-bottom: 10px;
}
.pc_goods_detail_right_score_change_title{
  padding-left: 10px;
  width: 70px;
  line-height: 26px;
}
.pc_goods_detail_right_score_change_item{
  max-width: 300px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid #666;
  color: #666;
  padding: 2px 10px;
  cursor: pointer;
  margin-bottom: 10px;
}
.pc_goods_detail_right_score_change_item_active{
  border: 2px solid #f60;
  padding: 1px 9px;
}
.pc_goods_detail_right_score_change_item:last-child{
  margin-bottom: 0;
}
.pc_goods_detail_right_score_change{
  margin-bottom: 10px;
}
.pc_goods_detail_right_attr_item_name{
  padding-left: 10px;
  width: 70px;
  line-height: 26px
}
.pc_goods_detail_right_attr_val{
  cursor: pointer;
  height: 25px;
  line-height: 24px;
  display: block;
  color: #666;
  height: 24px;
  text-decoration: none;
  border: 1px solid #666;
  padding: 0 13px;
  margin-right: 10px;
}
.pc_goods_detail_right_attr_val_active{
  border: 1px solid #ff7d00;
}
.pc_goods_detail_right_attr_val_prohibit{
  border: 1px dashed #ababab;
  color:#ababab;
}
.pc_goods_detail_right_attr_item{
  margin-bottom: 10px;
}
.pc_goods_detail_right_attr_item:last-child{
  margin-bottom: 0;
}
.pc_goods_detail_right_attr_list{
  margin-bottom: 10px;
}
.pc_goods_detail_right_relation_goods{
  margin-bottom: 10px;
}
.pc_goods_detail_right_relation_goods_item{
  width: 205px;
  height: 30px;
  border: 1px dashed #ccc;
  padding: 5px;
  margin-right: 15px;
  margin-bottom: 10px;
  cursor: pointer;
}
.pc_goods_detail_right_relation_goods_item:nth-child(2n){
  margin-right: 0;
}
.pc_goods_detail_right_relation_goods_item_img{
  width: 30px;
  height: 30px;
}
.pc_goods_detail_right_relation_goods_item_img img{
  width: 30px;
  height: 30px;
}
.pc_goods_detail_right_relation_goods_item_name{
  width: 160px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pc_goods_detail_right_relation_goods_list{
  width: 460px;
}
.pc_goods_detail_right_num_reduce,.pc_goods_detail_right_num_plus{
  width: 22px;
  height: 22px;
  line-height: 22px;
  border: 1px solid #ccc;
  text-align: center;
  cursor: pointer;
}
.pc_goods_detail_right_num_input{
  width: 50px;
  height: 22px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.pc_goods_detail_right_num_input input{
  width: 50px;
  height: 22px;
  text-align: center;
  outline: none;
}
input[type=number] {  
  -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
  -webkit-appearance: none;  
  margin: 0;  
}
.pc_goods_detail_right_num_box{
  margin-bottom: 20px;
}
.pc_goods_detail_right_btn_box{
  margin-left: 80px;
}
.pc_goods_detail_right_btn_team,.pc_goods_detail_right_btn_add{
  padding: 11px 23px;
  background: #fa0;
  border-radius: 5px;
  color: #fff;
  margin-right: 10px;
  font-size: 15px;
  cursor: pointer;
}
.pc_goods_detail_right_btn_add{
  background: #e00;
}
.pc_goods_detail_right_btn_add_active{
  background: #ccc;
}
.pc_goods_detail_right_btn_buy_active{
  background: #ccc;
  border: 1px solid #ccc;
  color: #fff;
}
.pc_goods_detail_right_btn_buy{
  padding: 10px 22px;
  background: #ffeded;
  border: 1px solid #e00;
  color: #e00;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
}
.pc_goods_detail_mask{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .4)
}
.pc_goods_detail_add_success{
  width: 470px;
  height: 220px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
}
.pc_goods_detail_add_success_title{
  height: 50px;
  background: #f3f3f3;
  text-align: center;
  font-weight: 900;
  font-size: 14px;
  line-height: 50px;
  margin-bottom: 38px;
}
.pc_goods_detail_add_success_content_img{
  width: 30px;
  height: 30px;
  margin-left: 48px;
  margin-top: 24px;
}
.pc_goods_detail_add_success_content_img img{
  width: 30px;
  height: 30px;
}
.pc_goods_detail_add_success_content_text{
  line-height: 80px;
  font-size: 16px;
  margin-left: 15px;
}
.pc_goods_detail_add_success_content_btn{
  width: 142px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  background: #e6a23c;
  color: #fff;
  margin-top: 20px;
  margin-left: 60px;
  cursor: pointer;
}
.pc_goods_detail_team{
  padding: 0 15px;
  width: 522px;
  height: 305px;
  background: #fff;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
}
.pc_goods_detail_team_price_box{
  padding-top: 20px;
  height: 70px;
}
.pc_goods_detail_team_price{
  margin-bottom: 15px;
}
.pc_goods_detail_team_price span{
  color: #fa0;
  font-size: 14px;
  margin-top: 10px;
  margin-right: 10px;
}
.pc_goods_detail_team_price i{
  color: #fa0;
  font-size: 22px;
  margin-top: 4px;
}
.pc_goods_detail_team_discount{
  margin-left: 80px;
  color: #e00;
}
.pc_goods_detail_team_attr{
  height: 100px;
  overflow-y: auto;
  margin-bottom: 15px;
}
.pc_goods_detail_team_attr_item{
  width: 158px;
  height: 35px;
  border:1px solid #ebebeb;
  text-align: center;
  line-height: 35px;
  margin: 0 8px 8px 0;
  color: #2c3e50;
  cursor: pointer;
}
.pc_goods_detail_team_attr_item_active{
  border: 1px solid #fa0;
}
.pc_goods_detail_team_attr_item:nth-child(3n){
  margin-right: 0;
}
.pc_goods_detail_team_num_title{
  line-height: 24px;
  width: 70px;
  margin-right: 10px;
}
.pc_goods_detail_team_num_box{
  margin-bottom: 10px;
}
.pc_goods_detail_team_btn{
  width: 80px;
  height: 34px;
  background: #fa0;
  border-radius: 5px;
  text-align: center;
  color: #fff;
  line-height: 34px;
  margin-right: 30px;
  cursor: pointer;
}
.pc_goods_detail_team_btn:nth-child(2){
  background: #ccc;
  margin-right: 0;
}
.pc_goods_detail_left_function_txt{
  width: 90px;
  height: 20px;
  line-height: 20px;
  cursor: pointer;
}
.pc_goods_detail_left_function_txt img{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.pc_goods_left{
  width: 193px;
}
.pc_goods_left_title{
  width: 191px;
  border: 1px solid #ededed;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #2c3e50;
  font-size: 14px;
  background: #fafafa;
}
.pc_goods_left_item{
  padding: 10px;
  border: 1px solid #ededed;
  border-top: 0;
  background: #fff;
}
.pc_goods_left_item_img{
  width: 171px;
  height: 171px;
  margin-bottom: 10px;
}
.pc_goods_left_item_img img{
  width: 171px;
  height: 171px;
}
.pc_goods_left_item_name{
  width: 100%;
  line-height: 16px;
  margin-bottom: 10px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.pc_goods_left_item_name:hover{
  color: #f60;
}
.pc_goods_left_item_price{
  color: #f60;
}
.pc_goods_detail_goods_right{
  width: 990px;
}
.pc_goods_detail_goods_right_title{
  width: 988px;
  height: 48px;
  background: #f7f7f7;
  border: 1px solid #ccc;
  border-bottom: 2px solid #fa0;
  margin-bottom: 20px;
}
.pc_goods_detail_goods_right_title_item{
  padding: 0 25px;
  line-height: 48px;
  font-size: 14px;
  cursor: pointer;
}
.pc_goods_detail_goods_right_title_item_active{
  background: #fa0;
  color: #fff;
}
.pc_goods_detail_goods_right_attr{
  border: 1px solid #ccc;
}
.pc_goods_detail_goods_right_attr_box{
  margin-top: 20px;
  background: #fff;
}
.pc_goods_detail_goods_right_attr_list{
  padding: 20px;
  padding-bottom: 0;
}
.pc_goods_detail_goods_right_attr_item{
  width: 400px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-bottom: 10px;

}
.pc_goods_detail_goods_right_attr_item:nth-child(2n){
  margin-right: 0;
}
.pc_goods_detail_goods_right_attr_more{
  text-align: right;
  margin-right: 50px;
  padding: 0 0 10px 0;
  cursor: pointer;
  color: #1042f8;
}
.pc_goods_detail_goods_right_img_box{
  border: 1px solid #ccc;
  margin-top: -1px;
}
.bdsharebuttonbox{
  margin-left: 90px;
  margin-top: 5px;
}
.bdsharebuttonbox .bds_qzone {
  background-position: 0 -52px;
}
.bdsharebuttonbox .bds_tsina {
  background-position: 0 -104px;
}
.bdsharebuttonbox .bds_tqq {
  background-position: 0 -260px;
}
.bdsharebuttonbox .bds_renren {
  background-position: 0 -208px;
}
.bdsharebuttonbox .bds_weixin {
  background-position: 0 -1612px;
}
.bdsharebuttonbox a, .bdsharebuttonbox .bds_more {
  float: left;
  font-size: 12px;
  padding-left: 17px;
  line-height: 16px;
  height: 16px;
  background-image: url(../../assets/img/icons_0_16.png);
  background-repeat: no-repeat;
  cursor: pointer;
  margin: 6px 6px 6px 0;
}
.pc_goods_detail_qrCode_box{
  width: 200px;
  height: 200px;
  padding: 50px;
  background: #fff;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
}
.pc_goods_detail_qrCode_img{
  width: 200px;
  height: 200px;
}
.pc_goods_detail_qrCode_img img{
  width: 200px;
}
.pc_goods_detail_qrCode_btn{
  width: 20px;
  height: 20px;
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}
.isFixed{
  position:fixed;
  top:0;
  z-index:999;
}
.pc_goods_detail_evaluation_item{
  padding: 20px;
  border-bottom: 1px solid #ccc;
}
.pc_goods_detail_evaluation_item:last-child{
  border-bottom: 0;
}
.pc_goods_detail_evaluation_member{
  width: 150px;
}
.pc_goods_detail_evaluation_member_ico{
  width: 25px;
  height: 25px;
  overflow: hidden;
  margin-right: 8px;
  border-radius: 50%;
}
.pc_goods_detail_evaluation_member_ico img{
  width: 25px;
  height: 25px;
}
.pc_goods_detail_evaluation_member_name{
  line-height: 25px;
  width: 100px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_goods_detail_evaluation_txt_box{
  width: 760px;
}
.pc_goods_detail_evaluation_txt_remark{
  line-height: 20px;
  margin: 10px 0;
}
.pc_goods_detail_evaluation_txt_pic{
  margin-bottom: 10px;
}
.pc_goods_detail_evaluation_txt_pic_item{
  width: 50px;
  height: 50px;
  border: 1px solid #eee;
  margin-right: 10px;
}
.pc_goods_detail_evaluation_txt_pic_item img{
  width: 50px;
  height: 50px;
}
.pc_goods_detail_evaluation_txt_add{
  color: #bbb;
  margin-bottom: 10px;
}
.pc_goods_detail_evaluation_txt_add_remark{
  margin-bottom: 10px;
  line-height: 20px;
}
.pc_goods_detail_evaluation_txt_add_reply{
  line-height: 20px;
  color: #fa0;
}
.pc_goods_detail_evaluation_txt_time{
  color:#bbb;
  line-height: 20px;
}
.participate_team{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 10px;
  max-height: 215px;
  overflow: hidden;
}
.participate_team_title{
  margin-bottom: 20px;
}
.participate_team_title p{
  font-size: 14px;
  color:#2c3e50;
}
.participate_team_list{
  height: 60px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 20px;
}
.participate_team_list:last-child{
  margin-bottom: 0;
}
.participate_team_list:last-child{
  border-bottom: 0;
}
.participate_team_list_num{
  height: 60px;
  width: 750px;
  border-right: 1px solid #ebebeb;
}
.participate_team_list_num .team_list_box{
  width: 100%;
  height: 60px;
  margin-top: 30px;
  overflow: hidden;
}
.participate_team_list_num .team_list{
  height: 60px;
}
.participate_team_list_num .team_item{
  width: 58px;
  height: 58px;
  border:1px solid #ddd;
  border-radius: 50%;
  font-size: 38px;
  color: #ebebeb;
  text-align: center;
  line-height: 60px;
  overflow: hidden;
}
.participate_team_list_num .team_list li{
  margin-right: 30px;
}
.participate_team_list_num .team_list li:last-child{
  margin-right: 0;
}
.participate_team_list_num .team_item img{
  width: 58px;
  height: 58px;
}
.participate_team_list_num .team_list_box{
  margin-top:0;
}
.participate_team_attribute{
  padding-left: 50px;
  padding-top: 10px;
}
.participate_team_attribute p{
  color:#2c3e50;
}
.participate_team_attr{
  margin-bottom: 15px;
}
.participate_team_time span{
  color:#fa0;
  font-size: 20px;
}
.participate_team_btn{
  padding: 16px 0 0 35px;
}
.participate_team_btn div{
  width: 86px;
  height: 30px;
  background:#fff;
  color: #fa0;
  border-radius: 5px;
  border: 1px solid #fa0;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.participate_team_btn .active{
  width: 88px;
  height: 32px;
  background: #cccccc;
  color:#fff;
  border: 0;
}
.participate_team_title_more{
  cursor: pointer;
}
.more_team{
  background: #ffffff;
  border-radius: 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform:translate(-50%,-50%);
  -moz-transform:translate(-50%,-50%);
  -o-transform:translate(-50%,-50%);
  -ms-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
  z-index: 10001;
  width: 1200px;
  height: 500px;
  padding-top: 30px;
}
.more_team_btn div{
  width: 80px;
  height: 34px;
  background: #ccc;
  border-radius: 5px;
  text-align: center;
  color: #fff;
  line-height: 36px;
  margin-right: 30px;
  cursor: pointer;
  margin: 30px auto;
}
.change_spell_team{
  height: 12px;
  color: #fa0;
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/goodsDetails/index.vue